import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { themeStyle, themeStyleDark } from "../components/Components";
import Sidebar from "../components/Sidebar";
import Footer from "../components/Footer";
import {
  ContentSideBySide,
  ContentSideBySideInv,
  ThreeSideBySide,
  Hero,
  Gallery,
  Stats,
  SpacerV,
} from "../components/Hero";
import { API_URL } from "../actions/auth";
import axios from "axios";
import { useNavigate } from "react-router";
import { TypeAnimation } from "react-type-animation";
import {
  OurProcess,
  Advantages,
  YouWillGet,
  Collage,
  FAQ,
  Collage2,
  Trust,
  Tailor,
} from "../components/Sections";
import { Grid } from "@mui/material";
import Lottie from "react-lottie";
import { layout } from "../components/Layout";

export default function ProgrammaticAdvertising() {
  const [news, setNews] = useState([]);
  const navigate = useNavigate();
  const state = useSelector((state) => state);
  function getContent() {
    return (
      <div className="main">
        <Sidebar />
        <div className="anigrad" style={{ backgroundColor: "white" }}>
          <div
            style={{
              height: state.auth.isMobile ? "130vh" : "100vh",
              display: "flex",
              flexDirection: "column",
              justifyContent: "center",
              alignItems: "center",
              width: "100vw",
            }}
          >
            <div
              style={{
                display: "flex",
                flexDirection: "column",
                justifyContent: "flex-start",
                alignItems: "flex-start",
                width: "75vw",
              }}
            >
              <div
                style={{
                  marginTop: state.auth.isMobile
                    ? state.auth.isTablet
                      ? "-300px"
                      : "-135px"
                    : "0px",
                  fontSize: state.auth.isMobile ? "25px" : "6vh",
                  color: "white",
                  zIndex: 999,
                  textAlign: "left",
                  marginBottom: "25px",
                  fontWeight: "bold",
                }}
              >
                <div
                  style={{
                    fontSize: layout.heading2[state.auth.view],
                  }}
                >
                  A Programmatic Advertising Agency
                  <br />
                  That Helps You Reach the Right Audience at the Right Time
                </div>
              </div>

              <div
                style={{
                  fontSize: layout.textMedium[state.auth.view],
                  color: "white",
                  zIndex: 999,
                  textAlign: "left",
                }}
              >
                At Riches Media Digital, we are more than just a programmatic
                advertising agency. We redefine digital advertising with
                precision targeting and real-time optimization. Our expertise
                guarantees that your brand connects with the right audience at
                the perfect moment.
              </div>
              <button
                style={{ marginTop: "6vh" }}
                onClick={() => {
                  navigate("/get-a-quote/");
                }}
                className="squishy"
              >
                Request a free estimate
              </button>
              <div
                style={{
                  display:
                    state.auth.isMobile || state.auth.view == "TABP"
                      ? "none"
                      : "block",
                }}
              >
                <Tailor
                  invert
                  title1="Tailor made"
                  subtitle1="Made with your brand in mind."
                  title2="Goal-oriented"
                  subtitle2="Made to reach business goals."
                  title3="Easy-to-Use"
                  subtitle3=" Add and edit with convenience."
                />
              </div>
            </div>
          </div>
          <Stats />
          {state.auth.isTablet ? (
            <SpacerV height={"300px"} background="#111" />
          ) : (
            ""
          )}
          <ContentSideBySide
            title={
              <h2>
                Driving Results Through Programmatic Advertising Solutions
              </h2>
            }
            subtitle={
              <div>
                At Riches Media Digital, we take a strategic and data-driven
                approach to programmatic advertising. Our team combines advanced
                technology and industry expertise to deliver high-performance
                campaigns. We make sure that your ads reach the most relevant
                audience and maximize engagement. Our tailored solutions help
                businesses scale efficiently and achieve higher conversion
                rates.
              </div>
            }
            image={
              <Lottie
                options={{
                  loop: true,
                  autoplay: true,
                  animationData: require("../img/temp2.json"),
                  rendererSettings: {
                    preserveAspectRatio: "xMidYMid slice",
                  },
                }}
                height={state.auth.isMobile ? 350 : 500}
                width={state.auth.isMobile ? 350 : 500}
                isStopped={false}
                isPaused={false}
              />
            }
          />
          <SpacerV height={"100px"} background={"white"} />
          <OurProcess
            process={"Programmatic Advertising Process"}
            invert
            step1={"Defining Goals and Audience"}
            step1description={
              "We work closely with advertisers to define clear objectives and audience parameters. Our targeting considers demographics and browsing behavior. We also analyze purchase history to refine audience selection and drive higher engagement."
            }
            step2={"Ad Inventory Acquisition via DSP"}
            step2description={
              "Our automated platforms analyze available inventory and match it with advertiser goals. We use real-time algorithms to assess placement quality and bid value. It delivers precise audience targeting and optimal ad placements."
            }
            step3={"Real-Time Bidding and Ad Placement"}
            step3description={
              "We leverage AI-driven auctions to determine the best impressions within milliseconds. Our highest bids secure premium placements on websites and apps. This makes sure that your ads appear where users are most active."
            }
            step4={"Tracking, Analyzing, and Optimizing"}
            step4description={
              "We monitor key performance indicators in real time. Our team continuously adjusts budgets and targeting to improve campaign effectiveness. We also optimize creative elements to boost engagement and conversions."
            }
          />
          <Advantages
            invert
            title="Advantages of Our Programmatic Advertising"
            title1={"Efficiency and Automation"}
            subtitle1={
              "We eliminate manual processes through AI-powered bidding. This optimizes ad spend and reduces inefficiencies while maximizing performance."
            }
            title2={"Precise Audience Targeting"}
            subtitle2={
              "We make sure that your ads reach users based on their interests and online behavior. This strategic targeting increases engagement and improves conversion rates."
            }
            title3={"Real-Time Optimization"}
            subtitle3={
              "Our campaigns adjust instantly based on performance data. We continuously refine bidding strategies and audience segments to maximize impact."
            }
            title4={"Cost-Effective and Scalable"}
            subtitle4={
              "Our programmatic approach guarantees that advertisers pay only for valuable impressions. We provide flexible budget allocation that scales effortlessly for businesses of all sizes."
            }
          />
          <ContentSideBySideInv
            title={<h2>The Secret Formula Behind Winning Ads</h2>}
            subtitle="At Riches Media Digital, we believe in a data-first approach. We combine first-party data from CRM systems with our proprietary insights to develop unique audience targeting strategies. We make sure that your ads reach users at the right time and on the right device. Our programmatic ad placements drive maximum efficiency and deliver higher revenue."
            image={
              <img
                style={{ width: "100%" }}
                src={require("../img/programmatic2.jpg")}
              />
            }
          />
          <SpacerV height="100px" background="white" />
          <YouWillGet
            willget={"What Programmatic Advertising Services Will You Get"}
            invert
            title1={"Targeting Accuracy"}
            title2={"Higher ROI value"}
            title3={"Time Saving Methods"}
            title4={"Real-Time Tracking"}
            title5={"Scalability & Flexibility"}
          />
          <div
            style={{
              display:
                state.auth.isMobile || state.auth.view == "TABP"
                  ? "none"
                  : "block",
            }}
          >
            <Trust invert />
          </div>
          <FAQ invert />
        </div>
        <Footer />
      </div>
    );
  }

  return (
    <div
      style={{
        height: "100%",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        backgroundColor:
          state.auth.theme == "dark"
            ? themeStyleDark.backgroundColor
            : themeStyle.backgroundColor,
        transition: "opacity 2s",
      }}
    >
      {getContent()}
    </div>
  );
}
